// extracted by mini-css-extract-plugin
export default {"text":"FormItemTitle_text__68t5A"};